{
  "id": "campaign-096",
  "name": "Misty Lane",
  "seed": "campaign:96",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    "..T..__..T..",
    "..q..__.....",
    ".%%..__.qX..",
    ".%...__.....",
    ".....__.....",
    ".i.i.__.i.i.",
    ".....__.....",
    ".....__.....",
    ".i.i.__.i.i.",
    "...*.__.*...",
    ".....__,,..,",
    ".i.i.__.i.i,",
    ".....__.....",
    ".....__.%...",
    "....x__.%%..",
    "......X.%...",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 4,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 14
    },
    {
      "kind": "rare",
      "x": 5,
      "y": 5
    }
  ],
  "generatorVersion": 3,
  "level": 96,
  "biome": "cemetery",
  "par": {
    "reel": 6784,
    "push": 5852,
    "selfPropelled": 5400,
    "tractor": 5000,
    "zeroTurn": 3556,
    "fairway": 2564
  },
  "routeTries": {
    "par": {
      "reel": 11,
      "push": 1,
      "selfPropelled": 24,
      "tractor": 19,
      "zeroTurn": 14,
      "fairway": 21
    }
  }
}
